import { getBrandName } from '../../../Utils/helper';

export const babiesPerMinute = 6;

export const getTotalBabiesBorn = () => {
  const current_date = new Date();
  const currentDay = current_date.getDate();
  const getOrders = ((currentDay - 1) * 24 * 60 * 60) / babiesPerMinute;
  const extraHours = current_date.getHours();
  const extraMins = current_date.getMinutes();
  const extraSeconds = current_date.getSeconds();
  const totalOrders =
    (extraHours * 60 * 60 + extraMins * 60) / babiesPerMinute +
    getOrders +
    Math.floor(extraSeconds / babiesPerMinute);
  return totalOrders;
};

export const mylobabyTrustData = [
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1696321532401-order-delivered.svg',
    text: '10 Lac+ orders delivered',
  },
  {
    image: 'https://images.myloapp.in/NestJsUploads/1696321532401-globe.svg',
    text: '1 Crore parents in India, USA, UK + 10 more countries trust Mylo',
  },
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1696321532400-thumbs-up.svg',
    text: '#1 parenting app on Google',
  },
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1696321532397-babies-born.svg',
    text: '10 Mylo Babies are born every minute',
  },
];

export const showTrustSection = (productId, userType) => {
  return false;
  return getBrandName(productId) === 'Mylo Baby' && userType === 'A';
};
